import { customHtml } from '@yola/ws-sdk';
import settingTypes from '../constants/setting-types';
import getFieldValuesFromSettings from './get-field-values-from-settings';

const customCodeFieldNamesList = Object.values(customHtml.constants.fieldNames);

/**
 * Empty site settings are not stored, so a missing key means "unset".
 * This returns a value for every field shown in Website settings, so that
 * a missing key equals the empty value of its form field.
 */
const getWebsiteSettingsDefaultValues = (settings) => ({
  ...getFieldValuesFromSettings(settings),
  [settingTypes.FAVICON]: settings[settingTypes.FAVICON] ?? '',
  [settingTypes.BUSINESS_CATEGORY]: settings[settingTypes.BUSINESS_CATEGORY] ?? null,
  [settingTypes.IS_COOKIE_BANNER_ENABLED]: settings[settingTypes.IS_COOKIE_BANNER_ENABLED] ?? false,
  [settingTypes.PREVENT_INDEXING]: settings[settingTypes.PREVENT_INDEXING] ?? false,
  ...Object.fromEntries(customCodeFieldNamesList.map((type) => [type, settings[type] ?? []])),
});

export default getWebsiteSettingsDefaultValues;
